<template>
  <!-- This component doesn't need hydration, so we don't pass any params -->
  <LazyHydrate>
    <StandardWrapper
      v-bind="$attrs"
      :blok="blok"
      no-section
      width="text"
      no-padding
    >
      <div class="prose prose-lg py-1 text-gray-800">
        <div
          class="flex h-12 items-center justify-end gap-x-3 align-middle font-content"
        >
          <div
            class="not-sr-only mr-3 block"
            :class="textColorClass(null, blok.bgVariant)"
          >
            Delen:
          </div>
          <template v-for="channel in channels" :key="channel.name">
            <SocialMediaLink :channel="channel" />
          </template>
        </div>
      </div>
    </StandardWrapper>
  </LazyHydrate>
</template>

<script setup>
import { computed } from 'vue'
import { usePageContext } from '../renderer/usePageContext'
import StandardWrapper from '../components/StandardWrapper.vue'
import SocialMediaLink from '../components/SocialMediaLink.vue'
import { useColorPalette } from '../composables/colorPalette'

const props = defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
})

const { textColorClass } = useColorPalette()
const pageContext = usePageContext()

const channels = computed(() => {
  const channels = props.blok.channels || []
  return channels.map((channel) => ({
    name: channel,
    label: `Delen op ${channel}`,
    url: channelUrl.value[channel],
  }))
})
const channelUrl = computed(() => {
  const host = pageContext.hostname || window.location?.host
  const url = `https://${host}${pageContext.urlOriginal}`

  let msg = ''
  if (props.context.vacancy) {
    msg = `Link naar de ${props.context.vacancy.title} vacature: `
  }

  return {
    twitter: `http://twitter.com/share?url=${url}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
    whatsapp: `https://wa.me/?text=${encodeURI(`${msg}${url}`)}`,
  }
})
</script>
